var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M9.882 8a4 4 0 0 1 3.954 3.399l.198 1.3A2 2 0 0 1 12.057 15H3.943a2 2 0 0 1-1.977-2.3l.197-1.301A4 4 0 0 1 6.118 8h3.764zm-6.73 3.55l-.198 1.3A1 1 0 0 0 3.943 14h8.114a1 1 0 0 0 .988-1.15l-.197-1.3A3 3 0 0 0 9.882 9H6.118a3 3 0 0 0-2.966 2.55zM8 1a3 3 0 0 1 3 3v1a3 3 0 1 1-6 0V4a3 3 0 0 1 3-3zm0 1a2 2 0 0 0-2 2v1a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2z" })
  );
});